// extracted by mini-css-extract-plugin
export var statItem = "_gr-1";
export var statsRow = "_gr-0";